var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsMenuActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27.996,
    viewBox: "0 0 28 27.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target_3064905",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39826",
    "data-name": "Path 39826",
    d: "M3.178,17.056C1.93,18.3.216,23.943.025,24.582a.584.584,0,0,0,.559.751.6.6,0,0,0,.168-.024c.638-.191,6.278-1.905,7.526-3.153a3.606,3.606,0,1,0-5.1-5.1Z",
    transform: "translate(0 2.666)",
    fill: "#ad52c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39827",
    "data-name": "Path 39827",
    d: "M25.549,13.392a.876.876,0,0,0-.812-.534l-2.042.015-.015-2.042a.875.875,0,0,0-1.5-.607l-2.894,2.938a.876.876,0,0,0-.252.621l.019,2.567c-.01.009-.024.013-.035.023L14.545,19.9a.875.875,0,1,0,1.247,1.228L19.266,17.6c.01-.01.014-.024.023-.035l2.567-.019a.873.873,0,0,0,.617-.261l2.894-2.938a.883.883,0,0,0,.181-.957Z",
    transform: "translate(2.382 1.66)",
    fill: "#ad52c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39828",
    "data-name": "Path 39828",
    d: "M17.282,14.583h0a8.231,8.231,0,0,1,1.295.106,2.6,2.6,0,0,1,.636-1.1l2.894-2.938a2.64,2.64,0,0,1,1.871-.783,2.6,2.6,0,0,1,.982.191,2.525,2.525,0,0,1,.3.176A19.92,19.92,0,0,0,27.787.575a.583.583,0,0,0-.569-.569c-5.466-.1-11.7,2.759-15.645,7.191A14.792,14.792,0,0,0,1.427,11.514a.583.583,0,0,0,.327.993l4.5.644-.555.622a.583.583,0,0,0,.023.8l4.641,4.641a7.626,7.626,0,0,1,6.923-4.633Zm.435-8.633a2.915,2.915,0,1,1,0,4.125,2.92,2.92,0,0,1,0-4.125Z",
    transform: "translate(0.209 0)",
    fill: "#ad52c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39829",
    "data-name": "Path 39829",
    d: "M21.576,18.632h-.828L19.36,20.043a3.5,3.5,0,0,1-6.988-.175,3.512,3.512,0,0,1,3.267-3.523L17,14.957V14.1a6.476,6.476,0,0,0-1.167-.1A5.833,5.833,0,1,0,21.7,19.8,5.5,5.5,0,0,0,21.576,18.632Z",
    transform: "translate(1.673 2.333)",
    fill: "#ad52c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsMenuActiveIcon);
export default __webpack_public_path__ + "static/media/projects_menu_active_icon.6de5ef99a7880aad9a54f43b75dc2bfa.svg";
export { ForwardRef as ReactComponent };